import React, { useEffect } from "react";
import { motion } from "framer-motion";

const gablecData = {
  ponedjeljak: [
    {
      id: 1,
      name: "Grillani svinjski vrat u lovačkom umaku",
      ingredients: "pommes, pola lepinje, svježa zelena salata",
      price: "7.90 €",
    },
  ],
  utorak: [
    {
      id: 2,
      name: "Grill pileći zabatak bez kosti uz rizi-bizi sa gljivama",
      ingredients: "svježa zelena salata, pola lepinje",
      price: "7.90 €",
    },
  ],
  srijeda: [
    {
      id: 3,
      name: "Ražnjići od svinjske lopatice (5 kom)",
      ingredients: "pommes + do aći bijeli umak, pola lepinje",
      price: "7.00 €",
    },
  ],
  cetvrtak: [
    {
      id: 4,
      name: "Pulled Pork Bowl",
      ingredients:
        "Hrskavi Wavy krumpirići začinjeni paprikom, otopljena gauda, polako pečena sočna svinjetina, domaći blagi umak, kukuruz i jalapeno papričice",
      price: "8.00 €",
    },
  ],
  petak: [
    {
      id: 5,
      name: "Pržene lignje ili panirani repovi račića",
      ingredients: "pommes ili blitva sa krumpirom, domaći bijeli umak i limun",
      price: "7.90 €",
    },
    {
      id: 10,
      name: "Pohani file oslića",
      ingredients:
        "Pommesom ili blitva sa krumpirom, domaći bijeli umak i limun",
      price: "6.90 €",
    },
  ],
};

const titleVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const GablecMenu = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="menu-page">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="main-title"
      >
        Tjedna ponuda gableca
      </motion.h1>

      {/* PONEDJELJAK */}
      <section id="ponedjeljak" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Ponedjeljak</h2>
        </motion.div>
        {gablecData.ponedjeljak.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* UTORAK */}
      <section id="utorak" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Utorak</h2>
        </motion.div>
        {gablecData.utorak.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SRIJEDA */}
      <section id="srijeda" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Srijeda</h2>
        </motion.div>
        {gablecData.srijeda.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* ČETVRTAK */}
      <section id="cetvrtak" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Četvrtak</h2>
        </motion.div>
        {gablecData.cetvrtak.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* PETAK */}
      <section id="petak" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Petak</h2>
        </motion.div>
        {gablecData.petak.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>
    </div>
  );
};

export default GablecMenu;
